import React from 'react'
import AltRouteOutlined from '@mui/icons-material/AltRouteOutlined'
import LocationOnOutlined from '@mui/icons-material/LocationOnOutlined'
import ShoppingCartOutlined from '@mui/icons-material/ShoppingCartOutlined'
import TrendingUpOutlined from '@mui/icons-material/TrendingUpOutlined'
import { formatMoney, countUniqueClients } from '../../../helpers/utils'
import { formatLastActivity } from './reportMobileUserCardUtils'

const iconSize = { fontSize: 20 }

export function buildReportOrdersUserMobileCardSections(model) {
  const userName = model.user_name ?? '—'
  const group = model.user_group ?? '—'
  const visited = model.total_visited_clients_count ?? 0
  const attended = model.total_attended_clients_count ?? 0
  const visitasStr = `${visited}/${attended}`
  const lastAct = formatLastActivity(model.order_last_visit)

  const summaryRows = [
    { label: 'Usuario', value: userName, valueTitle: userName },
    { label: 'Grupo', value: group, valueTitle: group },
    { label: 'Última actividad', value: lastAct, valueTitle: lastAct },
    { label: 'Visitas realizadas', value: visitasStr, valueTitle: visitasStr }
  ]

  const geo = `${model.order_location_effective_count ?? 0}/${model.order_location_available_count ?? 0}`

  const detailRows = [
    {
      icon: <AltRouteOutlined sx={iconSize} />,
      label: 'Visitas fuera de ruta',
      value: String(countUniqueClients(model.out_route_clients)),
      boldValue: true,
      valueTitle: String(countUniqueClients(model.out_route_clients))
    },
    {
      icon: <TrendingUpOutlined sx={iconSize} />,
      label: 'Efectividad',
      value: `${model.order_percent_effective ?? 0}%`,
      boldValue: true,
      valueTitle: `${model.order_percent_effective ?? 0}%`
    },
    {
      icon: <LocationOnOutlined sx={iconSize} />,
      label: 'Actividades en geocerca',
      value: geo,
      boldValue: true,
      valueTitle: geo
    },
    {
      icon: <ShoppingCartOutlined sx={iconSize} />,
      label: 'Total pedidos',
      value: formatMoney(model.total_order),
      boldValue: true,
      valueTitle: formatMoney(model.total_order)
    }
  ]

  return { summaryRows, detailRows }
}
